var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInvited = function SvgInvited(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 96 96"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "invited_svg__a",
    width: "105.6%",
    height: "110%",
    x: "-2.8%",
    y: "-4.1%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 4,
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "shadowBlurOuter1",
    values: "0 0 0 0 0 0 0 0 0 0.304622592 0 0 0 0 0.578497024 0 0 0 0.129971591 0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "invited_svg__b",
    d: "M0 0h824v460H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F7F8F9",
    d: "M-832-367H608V657H-832z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-364 -137)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#invited_svg__b",
    fill: "#000",
    filter: "url(#invited_svg__a)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#invited_svg__b",
    fill: "#FFF"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 44,
    fill: "#D0D7DE",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#6E7780",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M44 49c12.9 0 23.534 9.445 25 21.617C62.11 75.869 53.43 79 44 79s-18.109-3.13-25-8.381C20.467 58.445 31.1 49 44 49Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 35,
    r: 14,
    stroke: "#6E7780",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 80,
    r: 15,
    fill: "#F3F5F7",
    stroke: "#6E7780",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C83133",
    d: "M48 71a1 1 0 0 1 1 1v7.422l6.423 3.708a1 1 0 0 1-1 1.732l-6.928-4a1 1 0 0 1-.07-.044l.07.044a1 1 0 0 1-.143-.1 1 1 0 0 1-.353-.86L47 72a1 1 0 0 1 1-1"
  })))));
};
export default SvgInvited;